
import type { TimelineAPIInterface } from './api-switcher'
import { client } from './client'
import { responseDataConverter, apiPhotoToMyPhoto } from './converters'

export const TimelineAPI: TimelineAPIInterface = {
  listMainTimeline: (desk, startTimestamp, limit = 20, signal) => responseDataConverter(
    client.GET('/timeline/main', {
      params: {
        query: {
          ...(startTimestamp !== undefined && { startTimestamp: startTimestamp.getTime() }),
          direction: desk ? 'past' : 'future',
          limit
        }
      },
      signal
    }),
    (response) => response.photos.map(photo => ({
      ...apiPhotoToMyPhoto(photo),
      // Override added field with correct added_at value for timeline photos
      added: new Date(photo.added_at),
      favorite: photo.is_favorite || false,
      // Additional timeline-specific fields
      share_id: photo.share_id || '',
      share_name: photo.share_name || '',
      share_is_sensitive: photo.share_is_sensitive ?? false,
      user_id: photo.user_id,
      user_metamory_id: photo.user_metamory_id || '',
      user_name: photo.user_name,
      user_icon: `https://content.metamory.cc/icon/user/${photo.user_id}`
    }))
  ),

  listMeTimeline: (desk, startTimestamp, limit = 20, signal) => responseDataConverter(
    client.GET('/timeline/me', {
      params: {
        query: {
          ...(startTimestamp !== undefined && { startTimestamp: startTimestamp.getTime() }),
          direction: desk ? 'past' : 'future',
          limit
        }
      },
      signal
    }),
    (response) => response.photos.map(photo => ({
      ...apiPhotoToMyPhoto(photo),
      // Override added field with correct added_at value for timeline photos
      added: new Date(photo.added_at),
      favorite: photo.is_favorite || false,
      // Additional timeline-specific fields
      share_id: photo.share_id || '',
      share_name: photo.share_name || '',
      share_is_sensitive: photo.share_is_sensitive ?? false,
      user_id: photo.user_id,
      user_metamory_id: photo.user_metamory_id || '',
      user_name: photo.user_name,
      user_icon: `https://content.metamory.cc/icon/user/${photo.user_id}`
    }))
  ),

  listPromotionTimeline: (promotion_id, desk, startTimestamp, limit = 20, signal) => responseDataConverter(
    client.GET('/timeline/promotion/{promotion_id}', {
      params: {
        path: { promotion_id },
        query: {
          ...(startTimestamp !== undefined && { startTimestamp: startTimestamp.getTime() }),
          direction: desk ? 'past' : 'future',
          limit
        }
      },
      signal
    }),
    (response) => response.events.map(event => ({
      ...apiPhotoToMyPhoto(event.photo),
      added: new Date(event.added_at),
      favorite: event.photo.is_favorite || false,
      share_id: event.photo.share_id || '',
      share_name: event.photo.share_name || '',
      share_is_sensitive: event.photo.share_is_sensitive ?? false,
      user_id: event.photo.user_id,
      user_metamory_id: event.photo.user_metamory_id || '',
      user_name: event.photo.user_name,
      user_icon: `https://content.metamory.cc/icon/user/${event.photo.user_id}`
    }))
  ),

  getHomeTimelineUpdates: (since: number, signal?: AbortSignal) =>
    client.GET('/timeline/home/updates', {
      params: {
        query: { since }
      },
      signal
    }),

  appendPhotosToPromotionTimeline: (promotion_id: string, photo_ids: string[]) =>
    Promise.all(photo_ids.map(photo_id =>
      client.POST('/timeline/promotion/{promotion_id}/photos', {
        params: { path: { promotion_id } },
        body: { photo_id }
      })
    )).then(responses => {
      const firstError = responses.find(r => r.error)
      if (firstError?.error) {
        return {
          error: firstError.error,
          response: firstError.response
        }
      }
      return {
        response: responses[0].response
      }
    }),

  reportTimelinePhoto: (photo_id) => {
    console.log('reportTimelinePhoto (not implemented)', photo_id)
    return Promise.resolve({
      error: {code: 501, message: 'Not Implemented'},
      response: new Response('', {status: 501})
    })
  }
}